/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'CustomForm',

    components: {
        Badge,
        Checkbox,
        ColorPicker,
        HorizontalDivider,
        Toggler
    },

    props: {
        theme: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            advanced: false,
            color1: this.theme.color1,
            color2: this.theme.color2,
            color3: this.theme.color3,
            color4: this.theme.color4,
            color5: this.theme.color5,
            color6: this.theme.color6,
            color7: this.theme.color7,
            color8: this.theme.color8,
            color9: this.theme.color9,
            color10: this.theme.color10,
            color11: this.theme.color11,
            color12: this.theme.color12,
            tintIcons: this.theme.tintIcons
        };
    },

    methods: {
        emit() {
            this.$emit('change', {
                color1: this.color1,
                color2: this.color2,
                color3: this.color3,
                color4: this.color4,
                color5: this.color5,
                color6: this.color6,
                color7: this.color7,
                color8: this.color8,
                color9: this.color9,
                color10: this.color10,
                color11: this.color11,
                color12: this.color12,
                tintIcons: this.tintIcons
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-form"},[_c('section',{staticClass:"base-colours theme-elements"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color1"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color1","label":_vm.$t('theme.editor.colours.header_bg'),"tip":_vm.$t('theme.editor.colours.header_bg_tip'),"errors":errors},on:{"input":_vm.emit},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})]}}])}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color2"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color2","label":_vm.$t('theme.editor.colours.header_fg_custom'),"tip":_vm.$t('theme.editor.colours.header_fg_tip_custom'),"errors":errors},on:{"input":_vm.emit},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})]}}])}),_c('validation-provider',{attrs:{"slim":true,"name":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('toggler',{staticClass:"no-main-label",attrs:{"errors":errors,"on-label":"theme.editor.colours.enable_icons_tint","off-label":"theme.editor.colours.enable_icons_tint","hint":_vm.$t('theme.editor.colours.enable_icons_tint_hint'),"name":"enableTing"},on:{"input":_vm.emit},model:{value:(_vm.tintIcons),callback:function ($$v) {_vm.tintIcons=$$v},expression:"tintIcons"}})]}}])}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color4"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color4","label":_vm.$t('theme.editor.colours.menu_icons'),"disabled":!_vm.tintIcons,"errors":errors},on:{"input":_vm.emit},model:{value:(_vm.color4),callback:function ($$v) {_vm.color4=$$v},expression:"color4"}})]}}])}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color3"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color3","label":_vm.$t('theme.editor.colours.menu_fg'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color3),callback:function ($$v) {_vm.color3=$$v},expression:"color3"}})]}}])}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color5"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color5","label":_vm.$t('theme.editor.colours.navigation_selected'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color5),callback:function ($$v) {_vm.color5=$$v},expression:"color5"}})]}}])})],1),(_vm.advanced)?_c('section',{staticClass:"advanced"},[_c('horizontal-divider',{staticClass:"large"}),_c('div',{staticClass:"theme-elements"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color6"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color6","label":_vm.$t('theme.editor.colours.menu_username'),"errors":errors},on:{"input":_vm.emit},model:{value:(_vm.color6),callback:function ($$v) {_vm.color6=$$v},expression:"color6"}})]}}],null,false,2141282003)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color7"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color7","label":_vm.$t('theme.editor.colours.menu_workspace_name'),"errors":errors},on:{"input":_vm.emit},model:{value:(_vm.color7),callback:function ($$v) {_vm.color7=$$v},expression:"color7"}})]}}],null,false,2206759480)})],1),_c('horizontal-divider',{staticClass:"large"}),_c('div',{staticClass:"theme-elements"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color8"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color8","label":_vm.$t('theme.editor.colours.home_bg'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color8),callback:function ($$v) {_vm.color8=$$v},expression:"color8"}})]}}],null,false,3935529227)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color10"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color10","label":_vm.$t('theme.editor.colours.menu_section_separator_bg'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color10),callback:function ($$v) {_vm.color10=$$v},expression:"color10"}})]}}],null,false,3431466723)}),_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color11"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color11","label":_vm.$t('theme.editor.colours.menu_section_separator_fg'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color11),callback:function ($$v) {_vm.color11=$$v},expression:"color11"}})]}}],null,false,399102727)})],1),_c('horizontal-divider',{staticClass:"large"}),_c('div',{staticClass:"theme-elements"},[_c('validation-provider',{attrs:{"rules":"hex_color|required","slim":true,"name":"color12"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('color-picker',{attrs:{"name":"color12","label":_vm.$t('theme.editor.colours.session_reg_checkmark_bg'),"errors":errors},on:{"input":_vm.emit},scopedSlots:_vm._u([{key:"inside-label",fn:function(ref){return [_c('badge',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('theme.editor.mobile_only')))])]}}],null,true),model:{value:(_vm.color12),callback:function ($$v) {_vm.color12=$$v},expression:"color12"}})]}}],null,false,4178473753)})],1)],1):_vm._e(),_c('a',{staticClass:"more has-action",on:{"click":function($event){_vm.advanced = !_vm.advanced}}},[_vm._v(_vm._s(_vm.$t(("theme.editor.settings." + (_vm.advanced ? 'less' : 'more'))))),(_vm.advanced)?_c('i',{staticClass:"ic-chevron-up"}):_c('i',{staticClass:"ic-chevron-down"})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CustomForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__